export const VISUALIZER_MASK_RADIUS_SIZE_FACTOR = 0.4;
export const VISUALIZER_HEXAGON_GRADIENT_START = 'rgba(255,255,255,0.8)';
export const VISUALIZER_HEXAGON_GRADIENT_END = 'rgba(255,255,255,0.2)';
export const VISUALIZER_HEXAGON_STROKE_COLOR = 'rgba(255,255,255,0.9)';
export const VISUALIZER_HEXAGON_SIZE_FACTOR = 0.5;
export const VISUALIZER_HEXAGON_SIZE_FACTOR_XS = 0.1;
export const VISUALIZER_SPEED_MULTIPLIER = 1;
export const VISUALIZER_SPEED_MULTIPLIER_XS = 0.3;
export const VISUALIZER_FRAMES_PER_SECOND = 60;

// The max width is set to be a reasonable reading width, since messages stretch all the way
// from one side to the other. We assume that the max reasonable reading width is our small
// breakpoint, 768px.
export const MAX_WIDTH_CLASS = 'max-w-[768px]';
